import { MappedCatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import {
    CustomListItem,
    getCustomListCatalogItem,
    getCustomListCatalogItemId,
} from 'entities/CustomList';

/**
 * Build `selectedItems` entries for rows already on a custom list (lists add-items).
 * Keys match `getItemUid` for `lists-add-items` (`uuid ?? id`).
 */
export const mapCustomListItemsToSelection = (
    items: CustomListItem[],
): Record<string, Partial<MappedCatalogItem>> => {
    const selections: Record<string, Partial<MappedCatalogItem>> = {};

    items.forEach((listItem) => {
        const catalogItem = getCustomListCatalogItem(listItem);
        if (!catalogItem?.id && !catalogItem?.uuid) {
            return;
        }

        const key = catalogItem.uuid ?? catalogItem.id;
        const catalogItemId = getCustomListCatalogItemId(listItem);

        selections[key] = {
            qty:
                listItem.targetQuantity && listItem.targetQuantity > 0
                    ? listItem.targetQuantity
                    : 1,
            customListItemId: listItem.id,
            catalogItemId,
            uuid: catalogItem.uuid,
        };
    });

    return selections;
};
